const About = () => {
  return (
    <div>
      <div>
        <div className="about">
          <img src="https://iili.io/HIPLBe9.md.jpg" alt="profile_pic" />
          <div>
            Hello! I'm Krish, IT under grad. When it comes to technology, there
            was always something that attracted me to learn and experiment with
            new things. The habit of asking questions for every new thing that
            attracted my eyes proved to be very beneficial to me. Exploring new
            things, finding answers, and creating something new is all that I
            do. The goal is to make something with which I can say that I have
            contributed something to the world! As a growing child, my parents
            always nurtured me and never let me stay in my comfort zone. <br />
            <br /> This motivated me to work hard and so I will make every
            effort to repay their struggle. I am very adaptive to any new
            Technology as it is my passion to explore new technologies. For my
            work, I put all of my dedication towards it. I am an enthusiastic
            and hard-working student at my University. I am a UG student of Dept
            of Information Technology at Charusat University.
          </div>
        </div>
        <br />
        <br />
        Here are a few technologies I've known thoroughly:
        <br />
        <ul className="skill-container">
          <li className="skill-tag"> ⚛ React.js</li>
          <li className="skill-tag"> 📱 GraphQL</li>
          <li className="skill-tag">
            {" "}
            <i className="fa-solid fa-database"></i> MongoDB
          </li>
          <li className="skill-tag">
            {" "}
            <i className="fa-brands fa-node-js"></i> Node.js{" "}
          </li>
          <li className="skill-tag"> 👩‍💻 TypeScript</li>
          <li className="skill-tag">
            {" "}
            <i className="fa-brands fa-docker"></i> Docker
          </li>
          <br />
        </ul>
        <ul className="skill-container">
          <li className="skill-tag">
            <i className="fa-brands fa-golang"></i> Go{" "}
          </li>
        </ul>
        <br />
        Some of my soft skills:
        <br />
        <ul className="skill-container">
          <li className="skill-tag">Leadership</li>
          <li className="skill-tag">Teamwork</li>
          <li className="skill-tag">Commitment</li>
          <li className="skill-tag">Multitasking</li>
        </ul>
      </div>
    </div>
  );
};

export default About;
